import { resources } from '@/libs/acl/resources';

export default [{
    header: 'Reportes',
    title: 'Reportes',
    key: 'contractors_reports',
    icon: 'BarChartIcon',
    route: 'contractors-reports',
    resource: resources.CONTRACTOR_REPORTS
}];